import { css } from "styled-components";

export const payment = { card: "card", phone: "phone", withoutPassbook: "withoutPassbook" } as const;
export const willAutoBackup = { on: "on", off: "off" } as const;

export const gridNumbers = { xxl: 6, xl: 5, l: 4, m: 3, s: 2, xs: 1 } as const;
export const gridSizes = { xxl: "xxl", xl: "xl", l: "l", m: "m", s: "s", xs: "xs" } as const;
export const gridValues = {
   xxl: {
      count: 24,
      min: 1400,
      columnGap: "0px",
      rowGap: "20px",
      marginVertical: "0px",
      marginHorizontal: "0px",
   },
   xl: {
      count: 16,
      min: 1200,
      columnGap: "0px",
      rowGap: "20px",
      marginVertical: "0px",
      marginHorizontal: "0px",
   }, // >= 1200
   l: {
      count: 12,
      min: 992,
      columnGap: "0px",
      rowGap: "20px",
      marginVertical: "0px",
      marginHorizontal: "0px",
   }, // >= 992
   m: {
      count: 4,
      min: 768,
      columnGap: "0px",
      rowGap: "20px",
      marginVertical: "0px",
      marginHorizontal: "0px",
   }, // >= 768
   s: {
      count: 2,
      min: 576,
      columnGap: "0px",
      rowGap: "20px",
      marginVertical: "0px",
      marginHorizontal: "0px",
   }, // >= 576
   xs: {
      count: 2,
      min: 0,
      columnGap: "0px",
      rowGap: "20px",
      marginVertical: "0px",
      marginHorizontal: "0px",
   },
} as const;
export const apiStatuses = { idle: "idle", pending: "pending", resolved: "resolved", rejected: "rejected" } as const;
export const typography = {
   xs: {},
   other: {
      h1: css`
         font-size: 24px;
         font-weight: 500;
      `,
      h2: css`
         font-size: 16px;
         font-weight: 700;
      `,
      t1: css`
         font-size: 22px;
         font-weight: 700;
      `,
      t2: css`
         font-size: 19px;
         font-weight: 900;
      `,
      t3: css`
         font-size: 17px;
         font-weight: 400;
      `,
      t4: css`
         font-size: 16px;
         font-weight: 700;
      `,
      t5: css`
         font-size: 15px;
         font-weight: 500;
      `,
      t6: css`
         font-size: 15px;
         font-weight: 400;
      `,
      t7: css`
         font-size: 14px;
         font-weight: 500;
      `,
      t8: css`
         font-size: 14px;
         font-weight: 400;
      `,
      t9: css`
         font-size: 13px;
         font-weight: 400;
      `,
      t10: css`
         font-size: 12px;
         font-weight: 400;
      `,
      t11: css`
         font-size: 11px;
         font-weight: 500;
      `,
      color: {
         black: ["#000"],
         gray: ["#9F9F9F", "#C4C4C4", "#D0D0D0", "#DCDCDC"],
         purple: ["#7F21F7", "#E5D7F8"],
      },
   },
} as const;
